// Angular dependencies
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Imports modules

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRouterModule {
}



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/app.router.ts